
function refreshCart() {
	$.ajax({
	  url: '/cart?view=sidecart',
	  dataType: 'HTML',
	  method: "GET",
	  success: function (htmlData) {
        let html_markup = $(htmlData);
        let data_replace = $(htmlData).html();
        $('#js_cart_replace').html(data_replace);
        let cart_count = $(`[data-cart-itemcount]`).attr('data-cart-itemcount');
        $('.js_cart_total').text(cart_count);
        console.log(cart_count);
        //$('#headercart').dropdown('toggle'); 
    
	 }
	});
  }

 
  $( document ).ready(function() {
$('.home-atc-button').on('click', function(e) {
 
	e.preventDefault();
	var variant_id = $(this).attr('data-pro-id');
	var quantity = 1;
   $(this).text('Toegevoegd ');
   $(this).css("background-color","#d56334");
	$.ajax({
	  type: 'POST',
	  url: '/cart/add.js', 
	  dataType: 'json',
	  data: { id: variant_id, quantity: quantity },
	  success: function() {
	   //window.location.href = "/cart";
           
					window.setTimeout(function () {
						$('.home-atc-button').html('In winkelwagen <span><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.4997 25.6666C11.144 25.6666 11.6663 25.1443 11.6663 24.4999C11.6663 23.8556 11.144 23.3333 10.4997 23.3333C9.85534 23.3333 9.33301 23.8556 9.33301 24.4999C9.33301 25.1443 9.85534 25.6666 10.4997 25.6666Z" stroke="#201312" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/><path d="M23.3337 25.6666C23.978 25.6666 24.5003 25.1443 24.5003 24.4999C24.5003 23.8556 23.978 23.3333 23.3337 23.3333C22.6893 23.3333 22.167 23.8556 22.167 24.4999C22.167 25.1443 22.6893 25.6666 23.3337 25.6666Z" stroke="#201312" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.16699 1.16675H5.83366L8.96033 16.7884C9.06701 17.3255 9.35922 17.808 9.7858 18.1514C10.2124 18.4948 10.7461 18.6772 11.2937 18.6667H22.6337C23.1812 18.6772 23.7149 18.4948 24.1415 18.1514C24.5681 17.808 24.8603 17.3255 24.967 16.7884L26.8337 7.00008H7.00033" stroke="#201312" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg></span>');
					 $('.home-atc-button').css("background-color","transparent");
                    }, 1000);
       refreshCart();
      
        
	},
	  error: function(data) {
		alert(data.responseJSON.description);
	  }
	});
  });

$('.add-to-cart-button').on('click', function(e) {
	e.preventDefault();
	//var variant_id = $(this).attr('data-pro-id');
	var variant_id = $("#selelct_default_dropdown option:selected").val();
	var quantity =  $('.js_drop_qty option:selected').val();
   
$(this).text('toegevoegd');
   $('.add-to-cart-button').css("opacity","0.7");
   console.log(variant_id, quantity);
 
	$.ajax({
	  type: 'POST',
	  url: '/cart/add.js',
	  dataType: 'json',
	  data: { id: variant_id, quantity: quantity },
	  success: function() {
	   //window.location.href = "/cart";

     
					window.setTimeout(function () {
                      $('.add-to-cart-button').css("opacity","1");
						$('.add-to-cart-button').text('In winkelwagen');
                      $('.add-to-cart-button').css("background-color","#d56334");
                        $('.add-to-cart-button').css("color","#fff");
					}, 1000);
       refreshCart();
      
        
	},
	  error: function(data) {
		alert(data.responseJSON.description);
	  }
	});
  });
 

  $('.extra-pdp-pro').on('click', function(e) {
	e.preventDefault();
	 
	var variant_id = $("#selelct_default_dropdown option:selected").val();
	var quantity =  $('.js_ext-sel_qty option:selected').attr('value');

   console.log(variant_id, quantity);
 
	$.ajax({
	  type: 'POST',
	  url: '/cart/add.js',
	  dataType: 'json',
	  data: { id: variant_id, quantity: quantity },
	  success: function() {
	   //window.location.href = "/cart";
       refreshCart();
      
        
	},
	  error: function(data) {
		alert(data.responseJSON.description);
	  }
	});
  });
 


  $('.js_product_click').on('click', function(e) {
  $('.add-to-cart-button').trigger('click');
  refreshCart();
 });    
 $(document).on('change',"[name='updates[]']",function(e){
	 
	$("#cart_form").eq(0).submit()
  });


});

$(document).on('click', '.cart-upsell-button', function (e) {

    e.preventDefault();
    let current_em = $(e.target);
    let parent = $(e.target).parents(".upsell-product").eq(0);
    let variant_id = $(e.target).attr('data-id');
    
   //let variant_id = $('.js-variant-selector').val();
    let quantity = 1;
    //alert(variant_id);
   $(this).text('Toegevoegd ');
  $(this).css("background-color","#d56334");
    let data = {};
    data.id = variant_id;
    data.quantity = quantity;

    $.ajax({
      url: "/cart/add.js",
      method: "POST",
      dataType: "JSON",
      data: data,
      success: function (data) {
       $("#cart").load(" #cart > *");
       $(".finaltotal").load(" .finaltotal > *");
    //     $(".subTotal").load(" .subTotal > *");
        //$(".js_cart_total").load(".js_cart_total > *");
    //     $(".js_cart_count").load(" .js_cart_count > *");
	setTimeout(function(){
		$.getJSON('/cart.js', function(cart){ 
			var result = cart.item_count;
			$('.js_cart_total').html(result);
          $('.cart-upsell-button').html('In winkelwagen <span><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.4997 25.6666C11.144 25.6666 11.6663 25.1443 11.6663 24.4999C11.6663 23.8556 11.144 23.3333 10.4997 23.3333C9.85534 23.3333 9.33301 23.8556 9.33301 24.4999C9.33301 25.1443 9.85534 25.6666 10.4997 25.6666Z" stroke="#201312" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/><path d="M23.3337 25.6666C23.978 25.6666 24.5003 25.1443 24.5003 24.4999C24.5003 23.8556 23.978 23.3333 23.3337 23.3333C22.6893 23.3333 22.167 23.8556 22.167 24.4999C22.167 25.1443 22.6893 25.6666 23.3337 25.6666Z" stroke="#201312" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.16699 1.16675H5.83366L8.96033 16.7884C9.06701 17.3255 9.35922 17.808 9.7858 18.1514C10.2124 18.4948 10.7461 18.6772 11.2937 18.6667H22.6337C23.1812 18.6772 23.7149 18.4948 24.1415 18.1514C24.5681 17.808 24.8603 17.3255 24.967 16.7884L26.8337 7.00008H7.00033" stroke="#201312" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg></span>');
          $('.cart-upsell-button').css("background-color","transparent");
		});
	},300);
        
        // $(current_em).parents('.upsell-product').remove();
        // if($('.cart-upsell-button').length == 0){
        // 	$('.upsell_protitle').hide(); 
        // }
         
        
      },
      error: function (error) {
        alert("Sorry, that option is not available currently!");
        return false;

      }
    });
   
  });  
  $(document).ready(function() {
   
	$(document).on('click', '.productitem--action-trigger', function(e){

	e.preventDefault();
	var currentElement = $(this);
	var variant_id = $(currentElement).attr('data-variant-id');
	var quantity =  1;
  $(this).text('Toegevoegd ');
  $(this).css("background-color","#d56334");

   console.log(variant_id, quantity);
 
	$.ajax({
	  type: 'POST',
	  url: '/cart/add.js',
	  dataType: 'json',
	  data: { id: variant_id, quantity: quantity },
	  success: function() {
	   //window.location.href = "/cart";
      //   window.setTimeout(function () {
						// $('.productitem--action-trigger').html('ADD TO CART <span><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.4997 25.6666C11.144 25.6666 11.6663 25.1443 11.6663 24.4999C11.6663 23.8556 11.144 23.3333 10.4997 23.3333C9.85534 23.3333 9.33301 23.8556 9.33301 24.4999C9.33301 25.1443 9.85534 25.6666 10.4997 25.6666Z" stroke="#201312" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path><path d="M23.3337 25.6666C23.978 25.6666 24.5003 25.1443 24.5003 24.4999C24.5003 23.8556 23.978 23.3333 23.3337 23.3333C22.6893 23.3333 22.167 23.8556 22.167 24.4999C22.167 25.1443 22.6893 25.6666 23.3337 25.6666Z" stroke="#201312" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1.16699 1.16675H5.83366L8.96033 16.7884C9.06701 17.3255 9.35922 17.808 9.7858 18.1514C10.2124 18.4948 10.7461 18.6772 11.2937 18.6667H22.6337C23.1812 18.6772 23.7149 18.4948 24.1415 18.1514C24.5681 17.808 24.8603 17.3255 24.967 16.7884L26.8337 7.00008H7.00033" stroke="#201312" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>');
					 //      $(".productitem--action-atc").css("background-color","transparent");
      //                      $(".btn-custom-outline:hover").css("color","#201312");

      //   }, 1000);

        window.setTimeout(function () {
						$('.productitem--action-trigger').html('In winkelwagen <img data-src="https://cdn.shopify.com/s/files/1/0570/2572/4577/files/icon-cart-black.svg" class="img-fluid lazyload">');
					    $('.productitem--action-trigger').css("background-color","transparent");
                        $(".btn-custom-outline:hover svg path").css("stroke","black")
                        $(".productitem--action-trigger").css("color","#000")
                    }, 1000);
       refreshCart();
      
        
	},
	  error: function(data) {
		alert(data.responseJSON.description);
	  }
	});
  });
});
$( document ).ready(function() {
	
$(".event-type-select").change(function() {
	console.log('code is running successfully')
	var selectedEventType = this.options[this.selectedIndex].value;
	console.log(selectedEventType);
	if (selectedEventType == "all") {
	  $('.collection_filter .data_filter').removeClass('js_hidden');
	} else {
	  $('.collection_filter .data_filter').addClass('js_hidden');
	  $('.collection_filter .data_filter[data-eventtype="' + selectedEventType + '"]').removeClass('js_hidden');
	}
  });

$(document).on( "click", ".js_whatsapp", function() {
	$('#pushdaddy-button').trigger('click');
  });
});

$( document ).ready(function() {
$('.selector-wrapper').attr('data-spark', 'b2c-only');
 

  });

$( document ).ready(function() {
setTimeout(function() {

  $('#boost-pfs-search-box-0').attr('placeholder', 'Waar ben je naar op zoek?');
}, 1000);
  });
